import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { MenuController, ActionSheetController } from '@ionic/angular';

import { TranslateService } from '@ngx-translate/core';

import { AuthenticationService } from '../services/authentication.service';
import { ConfigService } from '../services/config.service';

import { environment } from '../../environments/environment.prod';


@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: [
    './styles/login.page.scss'
  ]
})
export class LoginPage implements OnInit {
  loading = false;
  returnUrl: string = '/';
  error = null;
  errorCode = '';

  signup_disabled = true;

  config: any;

  version: string = environment.version || '0.0.0';
  build: string = environment.build || 'build';

  loginForm: UntypedFormGroup;

  validation_messages = {
    'email': [
      { type: 'required', message: 'APP.MESSAGE.VALIDATION.EmailRequired' },
      { type: 'pattern', message: 'APP.MESSAGE.VALIDATION.EnterValidEmail' }
    ],
    'password': [
      { type: 'required', message: 'APP.MESSAGE.VALIDATION.PasswordRequired' },
      { type: 'minlength', message: 'APP.MESSAGE.VALIDATION.PasswordMessage1' }
    ]
  };

  biev: any;

  constructor(
    public router: Router,
    public menu: MenuController,
    private actionSheetCtrl: ActionSheetController,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private configService: ConfigService
  ) {
    this.authenticationService.logout();

    const language = localStorage.getItem('language');
    if (language) {
      this.translate.use(language);
    }

    this.config = this.configService.getConfiguration();

    this.loginForm = new UntypedFormGroup({
      'email': new UntypedFormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
      ])),
      'password': new UntypedFormControl('', Validators.compose([
        Validators.minLength(5),
        Validators.required
      ]))
    });
  }

  ngOnInit(): void {
    const language = localStorage.getItem('language') || 'it';
    console.log('LoginPage', localStorage.getItem('language'), language);
    this.translate.setDefaultLang(language);
    this.translate.use(language);

    // fromEvent(window, 'beforeinstallprompt').subscribe((res: any) => {
    //   console.log(res);
    //   this.biev = res;
    //   this.installSheet();
    // });

    // fromEvent(window, 'appinstalled').subscribe(() => {
    //   this.biev = null;
    //   console.log('PWA was installed');
    // });
  }

  // Disable side menu for this page
  ionViewDidEnter(): void {
    this.error = null;
    this.errorCode = '';
    this.authenticationService.logout();
    this.menu.enable(false);
    this.loginForm.reset();
  }

  // Restore to default when leaving this page
  ionViewDidLeave(): void {
    this.menu.enable(true);
  }

  install() {
    if (this.biev) {
      this.biev.preventDefault();
      this.biev.prompt();
      this.biev.userChoice.then((choiceResult: { outcome: string }) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
      });
    }
  }

  async installSheet() {
    const _buttons: any[] = [
      {
        text: this.translate.instant('APP.BUTTON.InstallApp'),
        data: { action: 'install' }
      },
      {
        text: this.translate.instant('APP.BUTTON.Cancel'),
        role: 'cancel',
        data: { action: 'cancel' }
      }
    ];

    const actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('APP.TITLE.Install'),
      subHeader: this.translate.instant('APP.TITLE.Install_sub'),
      buttons: [ ..._buttons ],
    });

    await actionSheet.present();

    const result = await actionSheet.onDidDismiss();
    if (result && result.data) {
      switch (result.data.action) {
        case 'install':
          this.install();
          break;
        default:
          break;
      }
    }
  }

  doLogin(value: any) {
    this.error = null;
    this.errorCode = '';
    this.loading = true;
    this.authenticationService.login(value.email, value.password).subscribe({
        next: (response: any) => {
          if (!this.returnUrl || this.returnUrl === '/') {
            this.returnUrl = 'app/dashboard';
          }
          setTimeout(() => {
            this.router.navigate([this.returnUrl]);
          }, 500);
          this.loading = false;
        },
        error: (error: any) => {
          this.error = error;
          this.errorCode = error.error.status || '422';
          console.log('error', this.errorCode, error);
          this.loading = false;
        }
      });
  }

  goToForgotPassword(): void {
    console.log('redirect to forgot-password page');
  }

  reloadApp() {
    window.location.reload();
  }

  selectLanguage() {
    const languages = this.config.AppConfig.Languages || [];
    const actionSheet = this.actionSheetCtrl.create({
      header: this.translate.instant('APP.TITLE.SelectLanguage'),
      buttons: languages.map((language: any) => ({
        text: this.translate.instant(`APP.LANGUAGE.${language.language}`),
        handler: () => {
          this.translate.use(language.alpha2Code);
          localStorage.setItem('language', language.alpha2Code);
        }
      }))
    });
    actionSheet.then((res) => {
      res.present();
    });
  }
}
